import { useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEXTJS_RSC_LOGGED_IN_HUB_PAGE_241114 } from "@faire/web-api--source/indigofair/settings/NEXTJS_RSC_LOGGED_IN_HUB_PAGE_241114";
export var useAssignSettingLoggedInHubsRSCM1 = function() {
    return useAssignSetting(NEXTJS_RSC_LOGGED_IN_HUB_PAGE_241114);
};
